module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Prodigal Daughter")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "chaptitle-pre"
  }, [_c('img', {
    attrs: {
      "alt": "dot.jpg",
      "src": "images/dot.jpg"
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/07_part1"
    }
  }, [_c('span', {
    staticClass: "bolditalic"
  }, [_vm._v("PART ONE")]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "dot1.jpg",
      "src": "images/dot1.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bolditalic"
  }, [_vm._v(" Demetrius among the Slavs")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/08_prechap_04"
    }
  }, [_vm._v("Map")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/09_Chapter_01"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/10_Chapter_02"
    }
  }, [_vm._v("Byzantium on the Prairies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/11_Chapter_03"
    }
  }, [_vm._v("Hiking for Demetrius")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/12_Chapter_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mother Thessaloniki")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/13_Chapter_05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Miracles on the Ramparts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/14_Chapter_06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("History is the Dogma of Scars")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/15_Chapter_07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Demetrius among the Macedonians")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/16_Chapter_08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Demetrius among the Serbs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/17_Chapter_09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Demetrius among the Bulgarians")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/18_Chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Who is He Killing?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/19_Chapter_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Letting Go")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/20_Chapter_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lord, have Mercy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/21_Chapter_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Return to Canada")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/22_part2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bolditalic"
  }, [_vm._v("PART TWO")]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "dot1.jpg",
      "src": "images/dot1.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bolditalic"
  }, [_vm._v(" Demetrius in Byzantium")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/23_Chapter_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Interlude")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/24_Chapter_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Opening: The Mad Professor of Sirmium")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/25_Chapter_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Slavs in Byzantium")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/26_Chapter_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Byzantine Saint")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/27_Chapter_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Guardian Saint")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/28_Chapter_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Passion of Demetrius")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/29_Chapter_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Life and Death of St. Demetrius, a Young Man of \t \tThessalonica, April 304 (Two Versions)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/30_Epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Epilogue")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/31_Acknowledgements",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/32_Notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/33_Bibliography_Reading",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bibliography and Recommended Reading")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dae2c5e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06_Contents.vue
// module id = 69
// module chunks = 0